import React from 'react';

const PrivacyPolicy = () => {
    const supportEmail = "support@shopysync.com";
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">

                    <h1 className="display-5 fw-bold text-teal mb-4">Privacy Policy</h1>
                    <p className="text-muted mb-5">Last updated: January 22, 2026</p>

                    {/* 1. Introduction */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">1. Introduction</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            <strong>Shopy Sync</strong> is a Shopify app that connects your <strong>Google Sheets</strong> with your <strong>Shopify store</strong> to sync product data.
                            We respect your privacy and only access data needed to perform syncs.
                        </p>
                    </section>

                    {/* 2. Data We Access */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">2. Data We Access</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            When you connect the app, we access:
                        </p>
                        <ul className="list-unstyled text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                            <li className="mb-2">• <strong>Google Sheets</strong>: The specific sheet you link for syncing.</li>
                            <li className="mb-2">• <strong>Basic Store Info</strong>: Store name, email, domain.</li>
                        </ul>
                        <p className="text-muted mt-3">
                            <strong>We do NOT access</strong>: product data, customer data, orders, payments, or personal information.
                        </p>
                    </section>

                    {/* 3. How We Use Data */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">3. How We Use Your Data</h2>
                        <ul className="list-unstyled text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                            <li className="mb-2">• To <strong>read</strong> products from Shopify or your Google Sheet.</li>
                            <li className="mb-2">• To <strong>write</strong> updates (add, edit, delete) during sync.</li>
                            <li className="mb-2">• To <strong>log sync activity</strong> for 30 days (for support and debugging).</li>
                        </ul>
                    </section>

                    {/* 4. Data Storage */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">4. Data Storage & Deletion</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            • We <strong>do not store</strong> your product data permanently.<br />
                            • Sync logs are <strong>automatically deleted after 30 days</strong>.<br />
                            • If you uninstall the app, all access is revoked immediately.
                        </p>
                    </section>

                    {/* 5. Shopify & Google */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">5. Third-Party Services</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            • We use <strong>Shopify Admin API</strong> to read/write store data.<br />
                            • We use <strong>Google Sheets API</strong> to read/write your sheet.<br />
                            • Both are secure, OAuth-based connections. You grant permission during setup.
                        </p>
                    </section>

                    {/* 6. Security */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">6. Security</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            • All connections use <strong>HTTPS</strong> and <strong>OAuth 2.0</strong>.<br />
                            • Access tokens are encrypted and never shared.<br />
                            • We follow Shopify and Google security best practices.
                        </p>
                    </section>

                    {/* 7. Your Rights */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">7. Your Rights</h2>
                        <ul className="list-unstyled text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                            <li className="mb-2">• Revoke access anytime via Shopify or Google settings.</li>
                            <li className="mb-2">• Request sync log deletion: email us.</li>
                            <li className="mb-2">• Uninstall the app to stop all data access.</li>
                        </ul>
                    </section>

                    {/* 8. Changes */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">8. Changes to Privacy Policy</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            We may update this policy. Continued use means you accept the changes.
                        </p>
                    </section>

                    {/* 9. Contact */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">9. Contact Us</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            Questions about privacy?<br />
                            Email: <a
                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=Support Request - Shopy Sync`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-teal"
                                style={{ marginLeft: '5px' }}
                            >
                                {supportEmail}
                            </a>
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;